const initialState = {
  count: 0,
  isAuthenticated: false,
  sidebarExpanded: false,
  user: {},
  store: { store_logo: "1722240569logo.png", store_title: "Templet-1" },
  sliders: ["https://campus.acetians.in/custom/image/lalitpur-logo.png"],
  notices: [],
  gallery_images: [
    {
      title: "61",
      imageUrl: "https://vbsgdc.org.in/uploads/2019/04/61-1.jpeg",
      thumbnailUrl: "https://vbsgdc.org.in/uploads/2019/04/61-1-150x150.jpeg",
    },
    {
      title: "64",
      imageUrl: "https://vbsgdc.org.in/uploads/2019/04/64.jpeg",
      thumbnailUrl: "https://vbsgdc.org.in/uploads/2019/04/64-150x150.jpeg",
    },
  ],
  courses: [],
  isLoggedIn: localStorage.getItem("tokken"),
  loginModale:false,
  registerModale:false,
  userData:null
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOGIN":
      return { ...state, isAuthenticated: true };
    case "LOGINMODALE":
      return { ...state, loginModale: action.payload ,registerModale : action.payload ? false : false   };
    case "REGISTERMODALE":
      return { ...state, registerModale: action.payload, loginModale : action.payload ? false : false  };
    case "EXPAND":
      return { ...state, sidebarExpanded: true };
    
    case "USERDATA":
      return { ...state, userData: action.payload };
    case "COMPRESS":
      return { ...state, sidebarExpanded: false };
    case "SET_STORE_DATA":
      return { ...state, store: action.payload };
    case "SET_STORE_SLIDERS":
      return { ...state, sliders: action.payload };
    case "SET_NOTICES":
      return { ...state, notices: action.payload };
    case "SET_GALLERY_IMAGES":
      return { ...state, gallery_images: action.payload };
    case "SET_COURSE_DATA":
      return { ...state, courses: action.payload };
    default:
      return state;
  }
};

export default rootReducer;
